export default __webpack_public_path__ + "static/media/twitter.657f18b2.png";